import { Button, Container, FormControl, InputLabel, makeStyles, MenuItem, OutlinedInput, Select } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { planEatApi } from '../../planEatApi/PlanEatApi';
import { IEaterGroupContent, IUserContent, IVersionedObject } from '../../planEatApi/PlanEatFacade';
import { HamburgerMenu } from '../../components/ui/HamburgerMenu';
import { useHistory } from 'react-router-dom';
import { FrontendApi } from '../../planEatApi/FrontendApi';
import { IEaterBookings, IEaterGroupUser } from '../../interface/interface';
import { EaterGroupContext, OfficeContext } from '../../config/Context';
import { IServiceUserInfo } from '../../datasolvr/ServicesFacade';
import { EaterGroupUserDeleteModal } from '../../components/modals/EaterGroupUserDeleteModal';
import { Logo } from '../../components/ui/Logo';
import toast from 'react-hot-toast';
import { icon_backButton, icon_hamburger } from '../../assets/images/images';
import { DataGrid } from '@material-ui/data-grid';
import { data_grid_eater_group_bookings_columns, data_grid_eater_group_users_columns } from '../../constants/dataGridHeaders';
import { monthAbbreviations, months, years } from '../../constants/dateAbbreviations';
import { InputField } from '../../components/ui/InputField';
import { resetEaterGroup } from '../../utils/resetObjects';
import { extractErrorMessage } from '../../components/utils/ErrorHandler';

const useStyles = makeStyles((theme: any) => ({
    content: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%", 

        "& > *": {
            width: "75%",
        }
    },
    title: {
        fontSize: '28px',
        fontWeight: 400,
        color: 'black',
        marginTop: 25,
        marginBottom:10
    },
    topbarContainer: {
        padding: 10,
        top: 0,
        left: 0,
        right: 0,
        width: '100vw',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    highLightedContainer:{
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(11, 37, 89, 0.1)',
        borderRadius: 8,
        padding: 15,
        marginBottom: 20
    },
    twoItemRow:{
        display: "grid",
        gridTemplateColumns: "50% 50%",
        width: "calc(100% - 25px)",
        columnGap: 25
    },
    buttonContainer:{
        display: 'grid',
        justifyContent: 'flex-end',
        gridTemplateColumns: '30%',
        width: '100%',
        marginTop: 15
    },
    inputContainer: {
        display: 'grid',
        maxWidth: '100%',
        gap: 15,
        rowGap: 25,
        gridTemplateColumns:'repeat(2, 1fr)',
        paddingTop  : 15,
    },
    twoButtonContainer: {
        display: 'grid',
        justifyContent: 'flex-end',
        gridTemplateColumns: '20% 20%',
        width: '100%',
        columnGap: 20,
        marginTop: 15
    }
}));

export const EaterGroupAdmin: React.FC = () => {
    // Styling
    const classes = useStyles();

    // Sate
    const [planEatEaterGroupUsers,setPlanEatEaterGroupUsers] = useState<IVersionedObject<IUserContent>[]>([]);
    const [eaterGroupUsers, setEaterGroupUsers] = useState<IEaterGroupUser[]>([])
    const [eaterGroup, setEaterGroup] = useState<IEaterGroupContent>()

    const [eaterBookings, setEaterBookings] = useState<IEaterBookings[]>([]);
    const [eaterGroupUserDeleteModalHidden,setEaterGroupUserDeleteModalHidden] = useState(true)

    const [open, setOpen] = useState(false);
    const [applicationUser, setApplicationUser] = useState<IServiceUserInfo>();
    const [applicationUsers, setApplicationUsers] = useState<IServiceUserInfo[]>([]);

    const [month, setMonth] = useState((new Date().getMonth()+1).toString());
    const [year, setYear] = useState(new Date().getUTCFullYear().toString());

    // Routing
    let history = useHistory();

   // Context 
   const eaterGroupContext = useContext(EaterGroupContext);

    useEffect(() => {
        getMyBookingList()
        getPlanEatEaterGroupUsers();
        getApplicationUsers()
    }, []);

    useEffect(() => {
        getPlanEatEaterGroupUsers();
        getEaterGroup()
    }, [eaterGroupContext?.eaterGroup]);

    const getMyBookingList = () => {
        FrontendApi.getEaterBookings(true, true).then((response) => {
            setEaterBookings(response);
        }).catch((e) => {
            console.log(e)
        })
    }

    function getApplicationUsers(){
        planEatApi.getServiceUsers()
        .then(response => {
            setApplicationUsers(response.data)
        })
        .catch(e => {
            console.log(e);
        })
    }

    const getPlanEatEaterGroupUsers = async () => {
            if(eaterGroupContext?.eaterGroup){
            var userId = localStorage.getItem('userId');
            if (userId) {
                await planEatApi.getUsers()
                .then(response => {
                    var tmpPlanEatUsers : IVersionedObject<IUserContent>[] = []
                    response.data.forEach((planEatUser) => {
                        if(planEatUser.content.eaterGroupId=== eaterGroupContext?.eaterGroup?.content.id){
                            if(tmpPlanEatUsers.length > 0){
                                var containsAlready = false;
                                tmpPlanEatUsers.forEach((tmpPlanEatUser) => {
                                    if(tmpPlanEatUser.content.id=== planEatUser.content.id){
                                        containsAlready = true;
                                    }
                                })

                                if(!containsAlready){
                                    tmpPlanEatUsers.push(planEatUser)
                                }
                            } else{
                                tmpPlanEatUsers.push(planEatUser)
                            }
                        }
                    })
                    setPlanEatEaterGroupUsers(tmpPlanEatUsers);
                })
                .catch(e => {
                    console.log(e)
                });
            }
        }
    }

    useEffect(() => {
        getEaterGroupUsers()
    },[planEatEaterGroupUsers])

    function getEaterGroupUsers(){
        var tmpEaterGroupUser: IEaterGroupUser[] = []

        planEatEaterGroupUsers.forEach(planEatEaterGroupUser => {
            applicationUsers.forEach(applicationUser => {
                if(applicationUser.content.id == planEatEaterGroupUser.content.applicationUserId){
                    tmpEaterGroupUser.push({
                        id: applicationUser.content.id,
                        name: applicationUser.content.name,
                        role: isAdmin(applicationUser.content.id)
                    })
                }
            })
        })
        setEaterGroupUsers(tmpEaterGroupUser)
    }

    const isAdmin = (applicationUserId: string) => {
        var isAdmin = false;

        if(eaterGroupContext?.eaterGroup){
            eaterGroupContext.eaterGroup.content.eaterGroupAdminIds.forEach((eaterGroupAdminId) => {
                if(eaterGroupAdminId=== applicationUserId){
                    isAdmin = true
                }
            })
        }
        return isAdmin ? "Admin" : "Employee"
    }

    const removeEaterGroupUser = (applicationUserId: string) => {
        planEatEaterGroupUsers.forEach((planEatEaterGroupUser) => {
            if(planEatEaterGroupUser.content.applicationUserId=== applicationUserId){
                planEatApi.postDeleteUserForEaterGroup(planEatEaterGroupUser.content.id)
                .then((response) => {
                    console.log(response)
                    getMyBookingList()
                    getPlanEatEaterGroupUsers();
                    toast.success("User "+planEatEaterGroupUser.content.name+" Removed from "+eaterGroupContext?.eaterGroup?.content.eaterGroupName)
                })
                .catch((e) => {
                    console.log(e)
                })
            }
        })
    }

    function getInvoice(){
        if(eaterGroupContext?.eaterGroup){
            planEatApi.getEaterGroupBookings(eaterGroupContext?.eaterGroup.content.id,month.toString(),year.toString())
            .then((response) =>{
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', eaterGroupContext?.eaterGroup?.content.eaterGroupName + "_" + monthAbbreviations[parseInt(month)-1] + '_' + year + '_' + 'invoicing.csv'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
            .catch((e) => {
                console.log(e)
            })
        }
    }

    function getEaterGroup(){
        if(eaterGroupContext?.eaterGroup){
            planEatApi.getEaterGroup(eaterGroupContext?.eaterGroup.content.id)
            .then((response) => {
                setEaterGroup(response.data.content)
            })
            .catch((e) => {
                console.log(e)
            })
        }
    }

    function updateEaterGroup(){
        if(eaterGroup){
            planEatApi.postEaterGroup(eaterGroup)
            .then((response) => {
                setEaterGroup(response.data.content)
                toast.success("Successfully updated eater group")
            })
            .catch((e) => {
                extractErrorMessage(e, "Failed updating information")
            })
        }
    }


    const handleMonthChange = (event: any) => {
        setMonth(event.target.value);
    };

    const handleYearChange = (event: any) => {
        setYear(event.target.value);
    };

    const handleEaterGroupChange = (prop: keyof IEaterGroupContent) => (event: React.ChangeEvent<HTMLInputElement>) => {
        eaterGroup && setEaterGroup({ ...eaterGroup, [prop]: event.target.value });
    };

    return (
        <div>
            <div className={classes.topbarContainer}>
                <div>
                    <img src={icon_backButton} alt="backButton" onClick={() => { history.push('booking') }} style={{ cursor: 'pointer' }} />
                </div>
                <Logo variant="small" />
                <img onClick={() => { setOpen(true) }} src={icon_hamburger} alt="hamburgerMenu" style={{ cursor: 'pointer' }} />
            </div>
            <div className={classes.content}> 
                <div className={classes.highLightedContainer}>
                    <div>
                        <div className={classes.title}>Eater Group code</div>
                        <div style={{marginLeft:5}}>{eaterGroupContext?.eaterGroup ? eaterGroupContext.eaterGroup.content.id : ""}</div>
                    </div>
                </div>
                <div className={classes.highLightedContainer}>
                    <div className={classes.title}>Download bookings</div>
                    <div className={classes.twoItemRow}>
                        <FormControl variant="outlined" style={{marginTop:10}}>
                            <InputLabel shrink>Month</InputLabel>
                            <Select
                                input={<OutlinedInput notched label="Month" />}
                                label='Month'
                                variant='outlined'
                                defaultValue={month}
                                onChange={handleMonthChange}
                                fullWidth
                            >
                                {months.map((tmpMonth) => <MenuItem key={tmpMonth.value} value={tmpMonth.value}>{tmpMonth.month}</MenuItem>)}    
                            </Select>
                        </FormControl>
                        <FormControl variant="outlined" style={{marginTop:10}}>
                            <InputLabel shrink>Year</InputLabel>
                            <Select
                                input={<OutlinedInput notched label="Year" />}
                                label='Year'
                                variant='outlined'
                                value={year}
                                onChange={handleYearChange}
                                fullWidth
                            >
                                {years.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </div>
                    <div className={classes.buttonContainer}>
                        <Button variant="contained" onClick={() => {getInvoice()}}>
                            Download
                        </Button>
                    </div>
                </div>
                <div className={classes.highLightedContainer}> 
                    <div className={classes.title}>Eater Group Information</div>
                    {
                        eaterGroup &&
                        <div>
                            <div className={classes.inputContainer}>
                                <InputField
                                    label="Company/Business name"
                                    variant="outlined"
                                    value={eaterGroup.eaterGroupName}
                                    onChange={handleEaterGroupChange('eaterGroupName')} 
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    required/>
                                <InputField
                                    label="Company CVR"
                                    variant="outlined"
                                    helperText='If you don´t have a CVR number, stay blank'
                                    value={eaterGroup.eaterGroupCVR}
                                    onChange={handleEaterGroupChange('eaterGroupCVR')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    required/>
                                <InputField
                                    label="Company Address"
                                    variant="outlined"
                                    value={eaterGroup.eaterGroupAddress}
                                    onChange={handleEaterGroupChange('eaterGroupAddress')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    required/>
                                <InputField
                                    label="Company Phone Number"
                                    variant="outlined" 
                                    value={eaterGroup.eaterGroupPhoneNumber}
                                    onChange={handleEaterGroupChange('eaterGroupPhoneNumber')}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    required/>
                            </div>
                            <div className={classes.twoButtonContainer}>
                                <Button variant="contained" onClick={() => {getEaterGroup()}}>
                                    Cancel
                                </Button>
                                <Button variant="contained" onClick={() => {updateEaterGroup()}}>
                                    Update information
                                </Button>
                            </div>
                        </div>
                    }
         
                </div>

                <div className={classes.highLightedContainer}>
                    <div className={classes.title}>Eater Group users</div>
                    <div>
                        <div style={{ display: 'flex', height: '300px' }}>
                            <div style={{ flexGrow: 1 }}>
                                <DataGrid
                                    rows={eaterGroupUsers}
                                    columns={data_grid_eater_group_users_columns}
                                    pageSize={10}
                                    rowsPerPageOptions={[10]}
                                    onRowClick={(e) => {setApplicationUser(applicationUsers.find(applicationUser => applicationUser.content.id === e.getValue(e.id,"id")));setEaterGroupUserDeleteModalHidden(false)}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.highLightedContainer}>
                    <div className={classes.title}>Eater Group bookings</div>
                    <div>
                        <div style={{ display: 'flex', height: '400px' }}>
                            <div style={{ flexGrow: 1 }}>
                                <DataGrid
                                    rows={eaterBookings}
                                    columns={data_grid_eater_group_bookings_columns}
                                    getRowId={(booking) => booking.bookingId}
                                    pageSize={10}
                                    rowsPerPageOptions={[10]}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {
                        applicationUser && eaterGroupContext?.eaterGroup ?
                        <EaterGroupUserDeleteModal 
                            applicationUser={applicationUser} 
                            eaterGroupName={eaterGroupContext?.eaterGroup?.content.eaterGroupName} 
                            eaterGroupUserDeleteModalHidden={eaterGroupUserDeleteModalHidden}
                            setEaterGroupUserDeleteModalHidden={setEaterGroupUserDeleteModalHidden}
                            removeEaterGroupUser={removeEaterGroupUser}
                        />
                    :
                        <div></div>
                    }
                </div>
                <HamburgerMenu open={open} setOpen={setOpen}>
                </HamburgerMenu>
            </div>
        </div >
    );
}